/**
 * Where the "Supported languages and frameworks" dialog lives (mounted once by the app, inside the router): it follows
 * supportedStacksDialog.js and loads the dialog the first time it opens, then keeps it so it can close smoothly.
 */
import React, { Suspense, useSyncExternalStore } from 'react';
import { closeSupportedStacks, subscribeSupportedStacks, supportedStacksState } from './supportedStacksDialog';

const SupportedStacksModal = React.lazy(() => import('./SupportedStacksModal'));

export default function SupportedStacksHost() {
  const state = useSyncExternalStore(subscribeSupportedStacks, supportedStacksState, supportedStacksState);
  if (!state.opened) { return null; }
  return (
    <Suspense fallback={null}>
      <SupportedStacksModal onClose={closeSupportedStacks} open={state.open} stack={state.stack} />
    </Suspense>
  );
}
